import { Box, Typography } from '@mui/material';
import { authService, getAppConfig } from 'framework-react-core';
import { useCallback, useMemo, useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Layout } from './components/layout/Layout.tsx';

export function ErrorRoot() {
  const error = useRouteError();

  const isAuthError = useMemo(() => {
    if (!isRouteErrorResponse(error)) {
      return false;
    }
    const data = error.data as { message?: unknown; redirect?: unknown } | undefined;
    const hasSignInMessage =
      typeof data?.message === 'string' && data.message.toLowerCase().includes('sign in');
    const hasRedirectPayload = typeof data?.redirect === 'string';
    return hasSignInMessage || hasRedirectPayload;
  }, [error]);

  const handleSignIn = useCallback(() => {
    const scopes = getAppConfig().getConfigValue<{ default: string[] }>(
      'FRAMEWORK_UI_AUTH_SCOPES'
    ).default;
    const redirectPath =
      isRouteErrorResponse(error) && typeof error.data?.redirect === 'string'
        ? error.data.redirect
        : null;
    if (redirectPath) {
      sessionStorage.setItem('post_login_redirect', redirectPath);
    }
    const redirectStartPage = redirectPath ? `${window.location.origin}${redirectPath}` : undefined;
    authService?.msalClient.loginRedirect({ scopes, redirectStartPage });
  }, [error]);

  useEffect(() => {
    if (isRouteErrorResponse(error) && typeof error.data?.redirect === 'string') {
      sessionStorage.setItem('post_login_redirect', error.data.redirect);
    }
  }, [error]);

  const msg = useMemo(() => {
    if (isRouteErrorResponse(error)) {
      if (typeof error.data?.message === 'string') {
        return error.data.message;
      }
      if (typeof error.statusText === 'string' && error.statusText.length > 0) {
        return error.statusText;
      }
    }
    return `Please login!`;
  }, [error]);

  return (
    <Layout title="Conflicts of Interest" menuOptions={[]}>
      <Box textAlign="center" p={10}>
        <Typography variant="h4" gutterBottom>
          {isAuthError && (
            <span
              onClick={handleSignIn}
              style={{
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              Sign In
            </span>
          )}{' '}
          {msg}
        </Typography>
      </Box>
    </Layout>
  );
}
